'use client'

import { useEffect, useState } from 'react'

const getWindowWidth = () => {
  if (typeof window === 'undefined') {
    return { width: 1024 } // Default width for SSR
  }
  const { innerWidth: width } = window
  return {
    width,
  }
}

export const useWindowWidth = (): {
  widthSmallerThan1024: boolean
  widthSmallerThan1280: boolean
  widthSmallerThan500: boolean
  widthSmallerThan768: boolean
} => {
  const [widthSmallerThan500, setWidthSmallerThan500] = useState<boolean>(false) // Default to false for SSR
  const [widthSmallerThan768, setWidthSmallerThan768] = useState<boolean>(false) // Default to false for SSR
  const [widthSmallerThan1024, setWidthSmallerThan1024] = useState<boolean>(false) // Default to false for SSR
  const [widthSmallerThan1280, setWidthSmallerThan1280] = useState<boolean>(true) // Default to true for SSR

  useEffect(() => {
    // Set initial values on client mount
    const { width } = getWindowWidth()
    setWidthSmallerThan500(width < 500)
    setWidthSmallerThan768(width < 768)
    setWidthSmallerThan1024(width < 1024)
    setWidthSmallerThan1280(width < 1280)

    const handleResize = () => {
      setWidthSmallerThan500(getWindowWidth().width < 500)
      setWidthSmallerThan768(getWindowWidth().width < 768)
      setWidthSmallerThan1024(getWindowWidth().width < 1024)
      setWidthSmallerThan1280(getWindowWidth().width < 1280)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return { widthSmallerThan500, widthSmallerThan768, widthSmallerThan1024, widthSmallerThan1280 }
}
